export const COLUMNS = [
  {
    Header: "Account Number",
    accessor: "MainAccountId",
    id: "MainAccountId"
  },
  {
    Header: "Description",
    accessor: "Description"
  },
  {
    Header: "Type",
    accessor: "Type.CodeDescription"
  },
  {
    Header: "Active",
    accessor: "Active",
    Cell: ({ cell }) => (cell.value ? "Yes" : "No")
  }
];
